import Vue from "vue";
import * as types from "../actionTypes";
import constants from "../../helpers/constants";
import { encodeBase64 } from "../../helpers/base64";
import { createDeepLink } from "../../helpers/branch.io";

export const actions = {
    [types.REFRESH_SHARED_LINKS_LIST]({ commit, dispatch, getters }) {
        commit(types.CLEAR_SHARED_LINKS_LIST);
        dispatch(types.CREATE_SHARED_LINK_ACTION, getters.activePlayback)
    },

    /** main action for creating shared link **/
    [types.CREATE_SHARED_LINK_ACTION]({ dispatch, commit, state }, data) {
        const mainPlaybackId = state.video.mainPlaybackData.data.id;
        const { id, attributes } = data;

        commit(types.CREATE_SHARED_LINK_LOADING, { id });

        Promise.resolve(
            attributes ?
                data :
                dispatch(types.CREATE_PLAYBACK_LINK, data)
        )
            .then(data => {
                if (!state.video.mainPlaybackData.data || state.video.mainPlaybackData.data.id !== mainPlaybackId) {
                    return;
                }

                return dispatch(types.CREATE_DEEP_LINK_REQUEST, data);
            })
            .then(link => {
                if (!state.video.mainPlaybackData.data || state.video.mainPlaybackData.data.id !== mainPlaybackId) {
                    return;
                }

                if (link) {
                    commit(types.CREATE_SHARED_LINK_SUCCESS, { id, link });
                }
            })
            .catch(error => {
                commit(types.CREATE_SHARED_LINK_FAILURE, { id, message: error.message });

                const message = constants.errorMessages.sharedLinkCreating;
                dispatch(types.SHOW_NOTIFICATION, { message }, { root: true });
            })
    },

    [types.CREATE_PLAYBACK_LINK]({ state }, { id, type }) {
        const tokenData = {
            id,
            event: state.urlHashData.event,
            type,
            token: state.urlHashData.token
        };

        const sharedLink = `${window.location.origin}${window.location.pathname}?token=${encodeBase64(tokenData)}`;

        const formattedData = {
            path: sharedLink,
            ...state.video.streams.data.find(item => item.id === id)
        };

        return formattedData;
    },

    /** action for creating a deep link via branch.io **/
    [types.CREATE_DEEP_LINK_REQUEST](context, data) {
        const { id, path, attributes, type } = data;

        return createDeepLink({
            id,
            attributes,
            path: path || window.location.href,
            type
        });
    },

    [types.CHANGE_ACTIVE_PLAYBACK]({ commit, dispatch, state: { video } }, id) {
        commit(types.SET_ACTIVE_PLAYBACK, id);

        const sharedLinkData = video.sharedLinksList[id];
        const isMainPlayback = video.mainPlaybackData.data.id === id;

        if (sharedLinkData || isMainPlayback) {
            return;
        }

        const type = video.streams.data.find(item => item.id === id).type;

        dispatch(types.CREATE_SHARED_LINK_ACTION, { id, type })
    }
}

export const mutations = {
    [types.CLEAR_SHARED_LINKS_LIST](state) {
        state.video.sharedLinksList = {};
    },
    [types.CREATE_SHARED_LINK_LOADING](state, payload) {
        Vue.set(state.video.sharedLinksList, payload.id, {
            link: '',
            loading: true,
            error: false,
            errorMessage: ''
        });
    },
    [types.CREATE_SHARED_LINK_SUCCESS](state, payload) {
        Vue.set(state.video.sharedLinksList, payload.id, {
            link: payload.link,
            loading: false,
            error: false,
            errorMessage: ''
        });
    },
    [types.CREATE_SHARED_LINK_FAILURE](state, payload) {
        Vue.set(state.video.sharedLinksList, payload.id, {
            link: '',
            loading: false,
            error: true,
            errorMessage: payload.message
        });
    },
    [types.SET_ACTIVE_PLAYBACK](state, payload) {
        state.video.activePlaybackId = payload;
    },
}

